/*
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
 */
const RootPath = window.g.baseUrl
const apis = {
  GetList: RootPath + 'plugin/websys/core/sections/GetList',
  Save: RootPath + 'plugin/websys/core/sections/Save',
  getmember:RootPath + 'plugin/websys/core/sections/GetMembers',
}

export default apis